module.exports = __webpack_public_path__ + "img/payment.16d6d125.png";